import React from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import Button from '../../buttons/Button';//eslint-disable-line import/no-named-as-default
import Resources from '../resourceLinks/ResourceLinks';
import Image from '../image/SecondaryImage';
import AudioControls from "../audio/SimpleAudioController";
import * as appDataActions from '../../../actions/appDataActions';
import * as trackingDataActions from '../../../actions/trackingDataActions';
import * as userDataActions from '../../../actions/userDataActions';
import * as dialogPopupActions from '../../../actions/dialogPopupActions';
import * as appConstants from "../../../constants/appConstants";
import * as appHelper from '../../../helpers/appHelper';
import * as userDataHelper from '../../../helpers/userDataHelper';
import * as objectConstants from '../../../constants/objectConstants';
import * as assetConstants from '../../../constants/assetConstants';
import * as imageHelper from '../../../helpers/imageHelper';
import {EXIT_CONFIG} from '../../../models/dialogModels';
import _ from 'lodash';
import * as animationHelper from "../../../helpers/animationHelper";

class Text extends React.Component {
    constructor(props, context) {
        super(props, context);
        this.state = {
            lang: this.props.lang,
            screenObject: this.props.screenObject,
            userData: this.props.userData,
            status: objectConstants.STATUS_NOT_STARTED,
            locale: appHelper.getLocalData(this.props.screenObject),
            showProgressionButton: false,
            icon: {
                src: "",
            },
            screenAsset: {
                src: ""
            },
            audio: {
                src: "",
            },
            hasLeftAsset: appHelper.isDefined(this.props.screenObject.left),
            hasRightAsset: appHelper.isDefined(this.props.screenObject.right),
            hasTopAsset: appHelper.isDefined(this.props.screenObject.top),
            hasBottomAsset: appHelper.isDefined(this.props.screenObject.bottom),
            assetData: {},

            screenStatus: "",
            checkComplete: false,
            resourceLinks: [],
            isResourceObject: appHelper.isDefined(this.props.callbacks.checkIsResourceScreen) && this.props.callbacks.checkIsResourceScreen(),
            hasResources: false,
            resourcesAreComplete: false,
            allowScroll: appHelper.allowScroll(this.props.callbacks.getBiteId(), this.props.callbacks.getScreenId(), this.props.screenObject.asset_id),
            progressionHandled: false,
            imageStyles: {},
            imageClass: "",
            updateImageStyles: false,
            imageStylesSet: false,
            refValue: `${this.props.screenObject.asset_id}_contentWrapper`,
            reviewBtn: {
                show: false,
                label: `${appHelper.getLocaleString("review_label")}`
            },
            clearBtn: {
                show: false,
                label: `${appHelper.getLocaleString("clear_and_start_again_label")}`
            },

            menuBtn: {
                show: false,
                label: `${appHelper.getLocaleString("return_to_menu_label")}`
            },
            exitBtn: {
                show: false,
                label: `${appHelper.getLocaleString("exit_label")}`
            },
            progressionLabel: `${appHelper.getLocaleString("continue_label")}`,
            creditLabel: `${appHelper.getLocaleString("credit_label")}`,
            download_audio_label: `${appHelper.getLocaleString("download_audio_label")}`,
            showLabels: true,
            showAnimation: true,
            updatedForced: false,
        };
        this.handleProgression = this.handleProgression.bind(this);
        this.scrollToTop = this.scrollToTop.bind(this);
        this.onComplete = this.onComplete.bind(this);
        this.enableProgression = this.enableProgression.bind(this);
        this.disableProgression = this.disableProgression.bind(this);
        this.getAssets = this.getAssets.bind(this);
        this.getAssetType = this.getAssetType.bind(this);
        this.getImagePath = this.getImagePath.bind(this);
        this.show = this.show.bind(this);
        this.onShowComplete = this.onShowComplete.bind(this);
        this.hide = this.hide.bind(this);
        this.onHideComplete = this.onHideComplete.bind(this);
        this.setClass = this.setClass.bind(this);
        this.setIconClass = this.setIconClass.bind(this);
        this.onProgressionBtnClicked = this.onProgressionBtnClicked.bind(this);
        this.getScreenStatus = this.getScreenStatus.bind(this);
        this.getObjectStatus = this.getObjectStatus.bind(this);
        this.onResourcesComplete = this.onResourcesComplete.bind(this);
        this.setResources = this.setResources.bind(this);
        this.onRendered = this.onRendered.bind(this);
        this.getImageStyles = _.debounce(this.getImageStyles.bind(this), 10);
        this.clearResults = this.clearResults.bind(this);
        this.onReview = this.onReview.bind(this);
        this.setDisplay = this.setDisplay.bind(this);
        this.goToMenu = this.goToMenu.bind(this);
        this.exit = this.exit.bind(this);
        this.handleEndProgression = this.handleEndProgression.bind(this);
        this.getAssetPath = this.getAssetPath.bind(this);

        this.textRef = React.createRef();
        this.containerRef = React.createRef();
    }

    componentDidMount() {
        this.setResources();
        this.getAssets();
        this.getImageStyles();
        this.getScreenStatus();
        this.show();
        this.setDisplay();

        if (appHelper.isDefined(this.props.callbacks.updateCharacterExpression) && appHelper.isDefined(this.state.screenObject.character_pose)) {
            this.props.callbacks.updateCharacterExpression(this.state.screenObject.character_pose);
        }
    }

    componentWillReceiveProps(nextProps) {
        if (this.state.userData !== nextProps.userData) {
            this.setState({userData: Object.assign({}, nextProps.userData)});
        }
        if (this.state.lang !== nextProps.lang) {
            this.setState({
                lang: nextProps.lang,
                locale: appHelper.getLocalData(this.state.screenObject),
                reviewBtn: {
                    label: `${appHelper.getLocaleString("review_label")}`
                },
                clearBtn: {
                    label: `${appHelper.getLocaleString("clear_and_start_again_label")}`
                },

                menuBtn: {
                    label: `${appHelper.getLocaleString("return_to_menu_label")}`
                },
                exitBtn: {
                    label: `${appHelper.getLocaleString("exit_label")}`
                },
                progressionLabel: `${appHelper.getLocaleString("continue_label")}`,
                creditLabel: `${appHelper.getLocaleString("credit_label")}`,
                download_audio_label: `${appHelper.getLocaleString("download_audio_label")}`,

            });
        }

    }

    componentDidUpdate() {

        if (this.state.checkComplete) {

            this.onComplete();
        }


        if (!this.state.imageStylesSet) {
            this.getImageStyles();
        }
    }

    setResources() {
        let resourceLinks = appHelper.setResourceLinks(this.state.screenObject);
        let hasRequiredResources = appHelper.hasRequiredResources(resourceLinks);

        this.setState({
            resourceLinks: Object.assign([], resourceLinks),
            hasResources: resourceLinks.length > 0,
            resourcesAreComplete: resourceLinks.length === 0 || !hasRequiredResources
        });

    }

    getScreenStatus() {
        let screenStatus = this.props.callbacks.getScreenStatus();
        this.setState({
            screenStatus: screenStatus,
            status: screenStatus === objectConstants.STATUS_COMPLETE ? objectConstants.STATUS_COMPLETE : this.state.status
        });
    }

    getObjectStatus() {
        if (this.state.screenStatus === objectConstants.STATUS_COMPLETE) {
            this.onComplete();
        } else {
            let objectUserData = {};
            if (this.state.status !== objectConstants.STATUS_COMPLETE) {
                let subScreenParent = this.props.callbacks.getSubScreenParent();
                let screen_id = this.props.callbacks.getScreenId();
                if (appHelper.isDefined(subScreenParent)) {
                    objectUserData = userDataHelper.getSubScreenObjectStatus(this.state.userData, subScreenParent.screen_id, screen_id, this.state.screenObject.asset_id);
                } else if (this.state.isResourceObject) {
                    objectUserData = userDataHelper.getResourceScreenObjectUserData(this.state.userData, screen_id, this.state.screenObject.asset_id);
                } else {
                    objectUserData = userDataHelper.getObjectStatus(this.state.userData, screen_id, this.state.screenObject.asset_id);
                }
            }
            if (objectUserData.status === objectConstants.STATUS_COMPLETE) {
                this.setState({status: objectConstants.STATUS_COMPLETE, checkComplete: true});
            } else {
                this.setState({checkComplete: true});
            }

        }

    }

    getImagePath(image) {
        if (appConstants.DEVELOPMENT_MODE) {
            if (appHelper.isDefined(image) && image.length > 0) {
                return require(`../../../../moveToDist/${image}`);
            }
        } else {
            return image;
        }
    }


    getAssetPath(asset) {
        if (appConstants.DEVELOPMENT_MODE) {
            if (appHelper.isDefined(asset) && asset.length > 0) {
                return require(`../../../../moveToDist/${asset}`);
            }
        } else {
            return asset;
        }
    }

    getAssets() {
        let screenAsset = {};
        let assetData = {};


        if (this.state.hasLeftAsset) {
            screenAsset = this.getAssetType(this.state.screenObject.left);
            assetData = Object.assign({}, this.state.screenObject.left);
        } else if (this.state.hasRightAsset) {
            screenAsset = this.getAssetType(this.state.screenObject.right);
            assetData = Object.assign({}, this.state.screenObject.right);
        } else if (this.state.hasTopAsset) {
            screenAsset = this.getAssetType(this.state.screenObject.top);
            assetData = Object.assign({}, this.state.screenObject.top);
        } else if (this.state.hasBottomAsset) {
            screenAsset = this.getAssetType(this.state.screenObject.bottom);
            assetData = Object.assign({}, this.state.screenObject.bottom);
        }
        if (appHelper.isDefined(this.state.locale.audio)) {

            let objectUserData = {};
            if (this.state.status !== objectConstants.STATUS_COMPLETE) {
                let subScreenParent = this.props.callbacks.getSubScreenParent();
                let screen_id = this.props.callbacks.getScreenId();
                if (appHelper.isDefined(subScreenParent)) {
                    objectUserData = userDataHelper.getSubScreenObjectStatus(this.state.userData, subScreenParent.screen_id, screen_id, this.state.screenObject.asset_id);
                } else if (this.state.isResourceObject) {
                    objectUserData = userDataHelper.getResourceScreenObjectUserData(this.state.userData, screen_id, this.state.screenObject.asset_id);
                } else {
                    objectUserData = userDataHelper.getObjectStatus(this.state.userData, screen_id, this.state.screenObject.asset_id);
                }
            }

            let audio = appHelper.getAudioAsset(this.state.locale.audio);
            let audioObj = {
                audioRef: `audio_${audio.id}_${audio.type}`
            };

            if ((appHelper.isDefined(this.state.screenObject.show_audio_controls) && !this.state.screenObject.show_audio_controls) || !appHelper.isDefined(this.state.screenObject.show_audio_controls)) {
                if (this.state.screenObject.autoplay_auto) {
                    this.props.actions.setAudio(audioObj);
                }
            }


            this.setState({
                audio: Object.assign({}, audio),
            });
        }

        if (assetData.constant === assetConstants.ASSET_TYPE_IMAGE) {
            assetData = Object.assign({}, assetData, {
                allow_diagram_zoom: this.state.screenObject.allow_diagram_zoom,
                show_diagram_title: this.state.screenObject.show_diagram_title,
                show_diagram_description: this.state.screenObject.show_diagram_description,
            });
        }

        this.setState({
            screenAsset: Object.assign({}, screenAsset),
            assetData: Object.assign({}, assetData)
        });

    }

    getAssetType(asset) {

        let returnAsset = {};
        if (asset.constant === assetConstants.ASSET_TYPE_ICON) {
            returnAsset = appHelper.getIconAsset(asset);
        } else if (asset.constant === assetConstants.ASSET_TYPE_IMAGE) {
            returnAsset = appHelper.getImageAsset(asset);
        } else if (asset.constant === assetConstants.ASSET_TYPE_LIBRARY_IMAGE) {
            returnAsset = appHelper.getLibraryImageAsset(asset);
        }
        returnAsset = appHelper.isDefined(returnAsset.locale) ? appHelper.getLocalData(returnAsset) : returnAsset;

        if (appHelper.isDefined(asset.constant) && !appHelper.isDefined(returnAsset.type)) {
            returnAsset = Object.assign({}, returnAsset, {
                type: asset.constant
            });
        }

        return returnAsset;
    }

    show() {
        let objectRef = this.containerRef.current;
        let params = {
            ele: objectRef,
            duration: objectConstants.SHOW_PANEL_DURATION,
            delay: 0,
            callback: this.onRendered
        };
        animationHelper.showHeight(params);
    }

    onRendered() {
        if (this.state.isResourceObject) {
            this.props.callbacks.onObjectRendered();
        }
        this.scrollToTop();
        this.getObjectStatus();
    }

    onShowComplete() {
        this.setState({isVisible: true, checkComplete: false});
    }

    hide() {
        let objectRef = this.containerRef.current;
        let params = {
            ele: objectRef,
            duration: objectConstants.SHOW_PANEL_DURATION,
            delay: 0,
            callback: this.onHideComplete
        };
        animationHelper.hideHeight(params);
    }

    onHideComplete() {
        this.setState({isVisible: false});
    }

    scrollToTop() {
        let screenStatus = this.props.callbacks.getScreenStatus();
        if (this.state.allowScroll && this.state.status !== objectConstants.STATUS_COMPLETE && screenStatus !== objectConstants.STATUS_COMPLETE) {
            let question = this.containerRef.current;
            let scrollTo = this.props.callbacks.scrollTo;
            setTimeout(function () {
                if (appHelper.isDefined(scrollTo)) {
                    scrollTo(question.offsetTop, true);
                }
            }, objectConstants.SCROLL_TO);
        }
    }

    onComplete() {
        this.setState({checkComplete: false});
        if (this.state.screenObject.progression === objectConstants.OBJECT_PROGRESSION_END) {
            if (this.state.resourcesAreComplete) {
                this.handleEndProgression();
            }
        } else {
            let hasNextObject = this.props.callbacks.hasNextObject(this.props.index);
            if (this.state.resourcesAreComplete) {
                if (appHelper.isDefined(this.state.screenObject.progression) && this.state.screenObject.progression === objectConstants.OBJECT_PROGRESSION_CONTINUE && (this.state.status !== objectConstants.STATUS_COMPLETE || !hasNextObject)) {
                    if (!hasNextObject && !this.state.isResourceObject) {
                        //console.log('progression 1')
                        this.handleProgression();
                        this.enableProgression();
                    } else if (!hasNextObject && this.state.isResourceObject) {
                        this.handleProgression();
                    } else if (this.state.isResourceObject) {
                        this.handleProgression();
                    } else {
                        this.enableProgression();
                    }

                } else {

                    this.handleProgression();
                }
            }
        }
        this.scrollToTop();
    }

    enableProgression() {
        if (!this.props.callbacks.isReviewMode()) {
            this.setState({showProgressionButton: true});
        }
    }

    disableProgression() {
        this.setState({showProgressionButton: false});
    }

    handleProgression() {
        if (!this.state.progressionHandled) {
            let hasNextObject = this.props.callbacks.hasNextObject(this.props.index);
            this.setState({progressionHandled: true});
            let progressionRule = this.state.screenObject.progression;
            let progressionType = appHelper.isDefined(this.state.screenObject.progression_type) ? this.state.screenObject.progression_type : undefined;
            let progressionGoToId = appHelper.isDefined(this.state.screenObject.progression_goto_id) ? this.state.screenObject.progression_goto_id : undefined;
            let completionData = {
                progression: progressionRule,
                progressionType: progressionType,
                progressionGoToId: progressionGoToId,
                asset_id: this.state.screenObject.asset_id,
                status: objectConstants.STATUS_COMPLETE,
                showProgressionButton: !hasNextObject,
                asset_type_code: this.state.screenObject.asset_type_code,
                navigateToNextScreen: !this.state.isResourceObject && appHelper.isDefined(this.state.screenObject.progression) && this.state.screenObject.progression === objectConstants.OBJECT_PROGRESSION_CONTINUE,
                index: this.props.index
            };

            this.props.callbacks.onObjectComplete(completionData);
        }
        //t

    }

    handleEndProgression() {
        let completionData = {
            progression: objectConstants.OBJECT_PROGRESSION_CONTINUE,
            asset_id: this.state.screenObject.asset_id,
            status: objectConstants.STATUS_COMPLETE,
            showProgressionButton: false,
            asset_type_code: this.state.screenObject.asset_type_code,
            navigateToNextScreen: appHelper.isDefined(this.state.screenObject.progression) && this.state.screenObject.progression === objectConstants.OBJECT_PROGRESSION_CONTINUE,
            index: this.props.index
        };

        this.props.callbacks.onObjectComplete(completionData);
    }

    onProgressionBtnClicked() {
        this.setState({showProgressionButton: false});
        if (this.props.callbacks.hasNextObject(this.props.index) || this.state.isResourceObject) {
            this.handleProgression();
        } else {
            this.props.callbacks.navigateToNextScreen();
        }
    }

    setClass() {

        let className = "";
        if (appHelper.isDefined(this.state.screenObject.class_name) && this.state.screenObject.class_name.length > 0) {
            className += ` ${this.state.screenObject.class_name}`;
        } else {
            className += "standard-block text-object";
        }

        if (appHelper.isDefined(this.state.screenObject.bullet_list_style) && this.state.screenObject.bullet_list_style !== null) {
            className += ` ${this.state.screenObject.bullet_list_style}`;
        }
        return className;
    }

    setIconClass() {
        let iconClass = '';

        if (this.state.hasLeftAsset) {

            iconClass += 'left-asset ';
        } else if (this.state.hasRightAsset) {
            iconClass += 'right-asset ';
        } else if (this.state.hasTopAsset) {
            iconClass += 'top-asset ';
        } else if (this.state.hasBottomAsset) {
            iconClass += 'bottom-asset ';
        }

        /*if (this.state.screenAsset.type === assetConstants.ASSET_TYPE_ICON) {
            iconClass += 'icon ';
        } else {
            iconClass += 'image ';
        }*/

        if (this.state.assetData.constant === assetConstants.ASSET_TYPE_IMAGE) {
            iconClass += 'image ';
        }
        return iconClass;
    }

    onResourcesComplete() {
        if (!this.state.resourcesAreComplete) {
            this.setState({resourcesAreComplete: true, checkComplete: true});
        }
    }

    getImageStyles() {
        let refValue = this.textRef.current;
        if (!this.state.updatedForced) {
            this.forceUpdate();
        }
        if (appHelper.isDefined(refValue) && refValue !== null && appHelper.isDefined(this.state.screenAsset.src) && this.state.screenAsset.src.length > 0) {
            let assetStyles = imageHelper.checkAssetImageWidth(this.state.screenObject, this.state.screenAsset, refValue.offsetWidth).styles;

            this.setState({
                updateImageStyles: false,
                imageStylesSet: true,
                updatedForced: false,
                imageStyles: Object.assign({}, assetStyles),
                imageClass: imageHelper.getAssetImageClass(this.state.screenObject),
            });
        }
    }

    clearResults() {
        let bite = appHelper.getBiteById(this.props.callbacks.getBiteId());
        this.props.actions.clearBiteUserData(bite).then((userData) => {
            this.props.actions.setSuspendData(userData).then((userData) => {
                this.onReview();
            }).catch(error => {
            });
        }).catch(error => {
        });
    }

    goToMenu() {
        this.context.router.push('menu');
    }

    onReview() {
        let bite = appHelper.getBiteById(this.props.callbacks.getBiteId());
        let go_to_screen_id = bite.screens[0].screen_id;
        if (this.props.contentData.experience.bites.length > 1) {
            go_to_screen_id = this.props.contentData.experience.bites[0].screens[0].screen_id;
        }
        this.props.callbacks.goToScreen(go_to_screen_id);
    }

    setDisplay() {
        if (this.state.screenObject.progression === objectConstants.OBJECT_PROGRESSION_END) {
            if (this.state.screenObject.end_action === objectConstants.END_ACTION_REVIEW) {
                this.setState({
                    reviewBtn: Object.assign({}, this.state.reviewBtn, {
                        show: true
                    })
                });

            } else if (this.state.screenObject.end_action === objectConstants.END_ACTION_REVIEW_OR_CLEAR) {
                this.setState({
                    reviewBtn: Object.assign({}, this.state.reviewBtn, {
                        show: true
                    }),
                    clearBtn: Object.assign({}, this.state.clearBtn, {
                        show: true
                    })
                });
            } else if (this.state.screenObject.end_action === objectConstants.END_ACTION_CLEAR) {
                this.setState({
                    clearBtn: Object.assign({}, this.state.clearBtn, {
                        show: true
                    })
                });

            } else if (this.state.screenObject.end_action === objectConstants.END_ACTION_RETURN_TO_MENU) {
                this.setState({
                    menuBtn: Object.assign({}, this.state.menuBtn, {
                        show: true
                    })
                });

            } else if (this.state.screenObject.end_action === objectConstants.END_ACTION_EXIT) {
                this.setState({
                    exitBtn: Object.assign({}, this.state.exitBtn, {
                        show: true
                    })
                });

            }
        }

    }

    exit() {
        this.props.actions.setNewDialog(EXIT_CONFIG);
    }


    render() {
        return (
            <div className="a-c" ref={this.containerRef}>
                <div className={`object-container`}>

                    <div className="object-wrapper">
                        {
                            appHelper.isDefined(this.props.characterPose) && appHelper.isDefined(this.props.characterPose.src) && this.props.characterPose.src.length > 0
                                ?
                                <div className={`content-character-expression`}>
                                    <img src={this.getImagePath(this.props.characterPose.src)} alt=""/>
                                </div>
                                :
                                null
                        }
                        <div className={`${this.setClass()}`}>
                            <div
                                className={`paragraph-content-wrapper ${this.setIconClass()} ${this.state.screenObject.image_size}-${this.state.screenObject.asset_image_width}`}
                                ref={this.textRef}>
                                {this.state.hasLeftAsset || this.state.hasTopAsset
                                    ?
                                    <div className={`asset-column`}>
                                        {this.state.assetData.constant === assetConstants.ASSET_TYPE_IMAGE && this.state.imageStylesSet
                                        &&
                                        <Image screenObject={this.state.assetData} imageClass={this.state.imageClass}
                                               imageStyles={this.state.imageStyles}/>

                                        }
                                        {this.state.assetData.constant !== assetConstants.ASSET_TYPE_IMAGE && this.state.imageStylesSet
                                        &&
                                        <div className={`asset-image-wrapper ${this.state.imageClass}`}
                                             style={this.state.imageStyles}>
                                            <img src={this.getImagePath(this.state.screenAsset.src)} alt=""/>
                                        </div>
                                        }

                                        {appHelper.isDefined(this.state.screenAsset.credit) && this.state.screenAsset.credit.length > 0 &&
                                        <div className={`image-credit`}
                                             style={this.state.imageStyles}>{this.state.creditLabel}: {this.state.screenAsset.credit}</div>
                                        }

                                    </div>
                                    :
                                    null
                                }
                                <div className="content-column">
                                    {
                                        this.state.screenObject.show_title && appHelper.isDefined(this.state.locale.label) && this.state.locale.label !== null && this.state.locale.label.length > 0
                                            ? <h4 className={this.state.screenObject.title_style}
                                                  dangerouslySetInnerHTML={{__html: this.state.locale.label}}/>
                                            : null
                                    }
                                    {appHelper.isDefined(this.state.locale.description) && this.state.locale.description !== null && this.state.locale.description.length > 0
                                        ?
                                        <div dangerouslySetInnerHTML={{__html: this.state.locale.description}}/>
                                        : null
                                    }
                                    <div className="flex-row-nowrap flex-align-content-center">
                                        {
                                            appHelper.isDefined(this.state.audio.id) && (appHelper.isDefined(this.state.screenObject.show_audio_controls) && this.state.screenObject.show_audio_controls)
                                                ?
                                                <div className="flex-item">
                                                    <AudioControls audio={this.state.audio}
                                                                   autoPlay={this.state.screenObject.autoplay_auto}
                                                                   showLabels={this.state.showLabels}
                                                                   showAnimation={this.state.showAnimation}
                                                                   audioRef={`text_audio_${this.state.screenObject.asset_id}_${this.state.audio.id}_${this.state.audio.type}`}/>
                                                </div>
                                                :
                                                null
                                        }
                                        {(appHelper.isDefined(this.state.audio.id) && (appHelper.isDefined(this.state.screenObject.show_audio_controls) && this.state.screenObject.show_audio_controls)) && (appHelper.isDefined(this.state.audio.id) && appHelper.isDefined(this.state.screenObject.download_audio_file) && this.state.screenObject.download_audio_file && appHelper.isDefined(this.state.audio.locale[this.state.lang].src) && this.state.audio.locale[this.state.lang].src.length > 0)
                                            ?
                                            <div className={`audio-container`}>
                                                <div style={{marginRight: `8px`}}>|</div>
                                            </div>
                                            :
                                            null
                                        }
                                        {
                                            appHelper.isDefined(this.state.audio.id) && appHelper.isDefined(this.state.screenObject.download_audio_file) && this.state.screenObject.download_audio_file && appHelper.isDefined(this.state.audio.locale[this.state.lang].src) && this.state.audio.locale[this.state.lang].src.length > 0

                                                ?
                                                <div className={`audio-container`}>
                                                    <div className="flex-item">
                                                        <div className="audio-download-container">
                                                            <a href={this.getAssetPath(this.state.audio.locale[this.state.lang].src)}
                                                               download
                                                               target="_blank" tabIndex={0}
                                                               className="audio-download">{this.state.download_audio_label}</a>
                                                        </div>
                                                    </div>
                                                </div>
                                                :
                                                null
                                        }

                                    </div>
                                    {
                                        this.state.hasResources
                                            ?

                                            <Resources resources={this.state.resourceLinks}
                                                       onResourcesComplete={this.onResourcesComplete}/>

                                            :
                                            null
                                    }


                                </div>
                                {this.state.hasRightAsset || this.state.hasBottomAsset
                                    ?
                                    <div className={`asset-column`}>
                                        {this.state.assetData.constant === assetConstants.ASSET_TYPE_IMAGE && this.state.imageStylesSet
                                        &&
                                        <Image screenObject={this.state.assetData} imageClass={this.state.imageClass}
                                               imageStyles={this.state.imageStyles}/>
                                        }
                                        {this.state.assetData.constant !== assetConstants.ASSET_TYPE_IMAGE && this.state.imageStylesSet
                                        &&
                                        <div className={`asset-image-wrapper ${this.state.imageClass}`}
                                             style={this.state.imageStyles}>
                                            <img src={this.getImagePath(this.state.screenAsset.src)} alt=""/>


                                        </div>
                                        }
                                        {appHelper.isDefined(this.state.screenAsset.credit) && this.state.screenAsset.credit.length > 0 &&
                                        <div className={`image-credit`}
                                             style={this.state.imageStyles}>{this.state.creditLabel}: {this.state.screenAsset.credit}</div>
                                        }
                                    </div>
                                    :
                                    null
                                }
                            </div>
                        </div>
                    </div>
                    <div className="inline-list text-center">
                        {this.state.reviewBtn.show
                            ?
                            <div className="inline-item">
                                <input className={`btn btn-lg guroo-btn action-btn`} type="button"
                                       value={this.state.reviewBtn.label} onClick={this.onReview}/>
                            </div>
                            : null
                        }
                        {this.state.clearBtn.show
                            ?
                            <div className="inline-item">
                                <input className={`btn btn-lg guroo-btn action-btn`} type="button"
                                       value={this.state.clearBtn.label}
                                       onClick={this.clearResults}/>
                            </div>
                            : null
                        }
                        {this.state.menuBtn.show
                            ?
                            <div className="inline-item">
                                <input className={`btn btn-lg guroo-btn action-btn`} type="button"
                                       value={this.state.menuBtn.label}
                                       onClick={this.onProgressionBtnClicked}/>
                            </div>
                            : null
                        }
                        {this.state.exitBtn.show
                            ?
                            <div className="inline-item">
                                <input className={`btn btn-lg guroo-btn action-btn`} type="button"
                                       value={this.state.exitBtn.label}
                                       onClick={this.exit}/>
                            </div>
                            : null
                        }
                    </div>
                    {this.state.showProgressionButton
                        ? <Button label={this.state.progressionLabel}
                                  id={`${this.state.screenObject}_button`}
                                  onClick={this.onProgressionBtnClicked}/>
                        : null
                    }
                </div>
            </div>
        );
    }
}

Text.propTypes = {
    screenObject: PropTypes.object.isRequired,
    callbacks: PropTypes.object.isRequired,
    index: PropTypes.number,
    characterPose: PropTypes.object,
    contentData: PropTypes.object.isRequired,
    trackingData: PropTypes.object.isRequired,
    userData: PropTypes.object.isRequired,
    lang: PropTypes.string.isRequired,
    actions: PropTypes.object.isRequired
};

Text.contextTypes = {
    router: PropTypes.object
};

function mapStateToProps(state, ownProps) {
    let lang = state.userData.lang;
    return {
        lang: lang,
        contentData: state.contentData,
        trackingData: state.trackingData,
        userData: state.userData
    };
}

function mapDispatchToProps(dispatch) {
    return {
        actions: bindActionCreators(Object.assign({}, appDataActions, trackingDataActions, userDataActions, dialogPopupActions), dispatch)
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(Text);



/** WEBPACK FOOTER **
 ** ./src/components/objects/text/Text.js
 **/